import { Organizations } from '../auth/organizations';
import { UserRoles } from '../auth/roles';

const pathPrefix = '';

export const Routes = {
  CaptureWarrant: `${pathPrefix}/jobs/captureWarrant`,
  CaptureTransaction: `${pathPrefix}/jobs/captureTransaction`,
  CaptureTransactionQA: `${pathPrefix}/jobs/captureTransactionQA`,
  IdentifyDocument: `${pathPrefix}/jobs/identifyDocument`,
  MergeSiblings: `${pathPrefix}/jobs/mergeSiblings`,
  Clarification: `${pathPrefix}/clarification`,
  TicketOverview: `${pathPrefix}/ticketOverview`,
  CorrectionTool: `${pathPrefix}/correctionTool`,
  Home: `${pathPrefix}/home`,
};

export const NavbarMainRoutes = [
  {
    url: Routes.IdentifyDocument,
    name: 'identifyDocument',
    roles: [UserRoles.DOCUMENT_CLASSIFICATION],
  },
  {
    url: Routes.CaptureTransaction,
    name: 'captureTransaction',
    roles: [
      UserRoles.TRANSACTION_DATA_CAPTURE,
      UserRoles.TRANSACTION_DATA_READ,
    ],
  },
  {
    url: Routes.CaptureTransactionQA,
    name: 'captureTransactionQA',
    roles: [
      UserRoles.TRANSACTION_DATA_CAPTURE_QA,
      UserRoles.TRANSACTION_DATA_READ,
    ],
  },
  {
    url: Routes.CaptureWarrant,
    name: 'captureWarrant',
    roles: [UserRoles.WARRANT_CAPTURE, UserRoles.WARRANT_READ],
  },
  {
    url: Routes.CorrectionTool,
    name: 'correctionTool',
    roles: [UserRoles.CORRECTION_TOOL],
  },
  {
    url: Routes.TicketOverview,
    name: 'ticketOverview',
    organizations: [
      Organizations.SMM,
      Organizations.ATRUVIA,
      Organizations.FINO,
    ],
    showNoLocks: true,
  },
];
